import { getPaginatedAccountsEndpoint, postImpersonateUserEndpoint } from '../accounts';
import { accountMeUrls } from '../accounts/accountMeUrls';
import { postCreateBookingAtStationEndpoint, postCreateBookingEndpoint } from '../bookings';
import { getDashboardUrls } from '../dashboard';
import { getFirstAvailableDeliveryWindowEndpoint, getLatestDeliveryWindowEndpoint } from '../deliveryWindows';
import { getIamUrls } from '../iam';
import { getCarTireQuotesEndpoint } from '../shop';
import { getUserGroupUrls } from '../userGroups';

const ignoringImpersonation = <Endpoint extends object>(endpoint: Endpoint) => ({
  ...endpoint,
  ignoreImpersonation: true as const
});

export const getImpersonationBypassUrls = {
  getPaginatedAccountsIgnoringImpersonation: ignoringImpersonation(getPaginatedAccountsEndpoint),
  postImpersonateUserIgnoringImpersonation: ignoringImpersonation(postImpersonateUserEndpoint),
  getPaginatedUserGroupsIgnoringImpersonation: ignoringImpersonation(getUserGroupUrls.getPaginatedUserGroups),
  getPaginatedFleetViewCarsIgnoringImpersonation: ignoringImpersonation(getDashboardUrls.getPaginatedFleetViewCars),
  getPaginatedIamRolesIgnoringImpersonation: ignoringImpersonation(getIamUrls.getPaginatedIamRoles),
  getPaginatedIamPoliciesIgnoringImpersonation: ignoringImpersonation(getIamUrls.getPaginatedIamPolicies),
  postCreateBookingIgnoringImpersonation: ignoringImpersonation(postCreateBookingEndpoint),
  postCreateBookingAtStationIgnoringImpersonation: ignoringImpersonation(postCreateBookingAtStationEndpoint),
  getLatestDeliveryWindowIgnoringImpersonation: ignoringImpersonation(getLatestDeliveryWindowEndpoint),
  getFirstAvailableDeliveryWindowIgnoringImpersonation: ignoringImpersonation(getFirstAvailableDeliveryWindowEndpoint),
  getCarTireQuotesIgnoringImpersonation: ignoringImpersonation(getCarTireQuotesEndpoint),
  patchAccountSettingsIgnoringImpersonation: ignoringImpersonation(accountMeUrls.patchAccountSettings)
};
